import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router";
import store from "./store";
import VueNoty from "vuejs-noty";
import "vuejs-noty/dist/vuejs-noty.css";
import JsonCSV from "vue-json-csv";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.component("downloadCsv", JsonCSV);

Vue.use(VueNoty, {
  timeout: 4000,
  progressBar: true,
  layout: "topRight"
});

//Authenticate each route. ensure no user enters the dashboard without being authenticated
/*router.beforeEach((to, from, next) => {
  //ignore this if from is /login
  if(from.fullPath != "/login"){
    //if vendor_id is not in the localstorage, go to login page
    if (localStorage.getItem("vendor_id") == null) {
      next("login");
    } else {
      next();
    }
  }
  
}); */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
